import { applyMiddleware, createStore, compose } from 'redux';
import reducer from './modules/reducer';
import ReduxThunk from 'redux-thunk';
// import createLogger from 'redux-logger';

// const logger = createLogger();
const composeEnhancers = (typeof window !== 'undefined') ? (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose) : compose;

const middleware = applyMiddleware(
    // logger,
    ReduxThunk,
);

const create = (preloadedState) => {
    return createStore(
        reducer,
        preloadedState,
        composeEnhancers(middleware),
    );
};

export default create;


/** WEBPACK FOOTER **
 ** ./src/redux/create.js
 **/